import { Grid, Box } from '@mui/material'
import { Card, ListItem } from 'components'
import { get } from 'lodash'
import { useLoadCustomer } from 'modules/customers/hooks'
import { useParams } from 'react-router-dom'
import { cellPhoneMask, phoneMask } from 'utils'

import { ModalContactProvider } from './context/modalContact.context'

const columnLeft: any = [
  {
    label: 'Nome',
    key: 'contact.name'
  },
  {
    label: 'Função/Cargo',
    key: 'contact.role'
  },
  {
    label: 'E-mail',
    key: 'contact.email'
  }
]

const columnRight = [
  {
    label: 'Telefone',
    key: 'contact.phone',
    transform: (value: string) => phoneMask(value)
  },
  {
    label: 'Celular',
    key: 'contact.cellPhone',
    transform: (value: string) => cellPhoneMask(value)
  },
  {
    label: 'Observação',
    key: 'contact.observation'
  }
]

const ContactsContexted = () => {
  const { id } = useParams()

  const { data: customer } = useLoadCustomer(id)

  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{
                visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
                padding: { xs: 0, sm: '24px', md: '24px' },
                maxWidth: 600
              }}
            >
              <Box
                sx={{
                  visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
                }}
              >
                <Grid container spacing={{ xs: 0, md: 3 }}>
                  <Grid item xs={12} md={6}>
                    {columnLeft?.map((item: any) => (
                      <ListItem
                        key={item.key}
                        label={item.label}
                        value={get(customer, item.key)}
                        transform={item?.transform}
                      />
                    ))}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    {columnRight?.map((item: any) => (
                      <ListItem
                        key={item.key}
                        label={item.label}
                        value={get(customer, item.key)}
                        transform={item.transform}
                      />
                    ))}
                  </Grid>
                </Grid>
              </Box>
            </Card>
            {/* <Divider sx={{ display: { xs: 'flex', sm: 'none', md: 'none' } }} /> */}
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export const Contacts = () => (
  <ModalContactProvider>
    <ContactsContexted />
  </ModalContactProvider>
)
